import React from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { TabView, TabPanel } from "primereact/tabview";
import AssetInputOrUploadSection from "./AssetInputOrUploadSection";
import InputTextSection from "./InputTextSection";
import { CREATIVE_NAMES, STORY_UNIT_AD_FIELDS, STORY_UNIT_SLOTS, STORY_UNIT_TYPES } from "./definitions";
import BaseCreativeControls from "./BaseCreativeControls";

const CREATIVE_TYPE = CREATIVE_NAMES.STORY_UNIT

/* Tab order of each story slot */
const SLOT_TYPES = [STORY_UNIT_TYPES.VIDEO, STORY_UNIT_TYPES.VAST]

/* The theme pads the panels by 1rem, which stacks on top of the padding of the inputs inside them */
const tabViewStyle = css`
    .p-tabview-panels {
        padding: 0;
    }
`

export default function StoryUnit(props) {
    const {
        handleChange,
        handleChanges,
        currentCustomer,
        impressionTag,
        clickTag,
        adServingType,
        desktopCreativeURL,
        container
    } = props

    return (
        <>
            <BaseCreativeControls
                adServingType={adServingType}
                changeHandler={handleChange}
                clickTag={clickTag}
                impressionTag={impressionTag}
                creativeType={CREATIVE_TYPE}
            >
                <AssetInputOrUploadSection
                    inputValue={desktopCreativeURL}
                    inputLabel="Desktop Creative"
                    inputName={STORY_UNIT_AD_FIELDS.desktopCreativeURL}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />
                {STORY_UNIT_SLOTS.map(slot => {
                    const typeName = STORY_UNIT_AD_FIELDS['story' + slot + 'Type']
                    const sourceName = STORY_UNIT_AD_FIELDS['story' + slot + 'Source']
                    const durationName = STORY_UNIT_AD_FIELDS['story' + slot + 'Duration']
                    const slotType = props[typeName] || STORY_UNIT_TYPES.VIDEO

                    return (
                        <div
                            key={slot}
                            style={{
                                border: '1px solid #e6edf2',
                                padding: '6px',
                                margin: '10px 0'
                            }}
                        >
                            <h4>VAST Tag #{slot}</h4>
                            <TabView
                                css={tabViewStyle}
                                activeIndex={SLOT_TYPES.indexOf(slotType)}
                                onTabChange={(e) => {
                                    /* A video URL is not a valid VAST tag and vice versa, so the source is cleared when switching */
                                    handleChanges({
                                        [typeName]: SLOT_TYPES[e.index],
                                        [sourceName]: "",
                                        [durationName]: ""
                                    })
                                }}
                            >
                                <TabPanel header="Upload video">
                                    <AssetInputOrUploadSection
                                        inputValue={props[sourceName]}
                                        inputLabel={`Video #${slot} URL (.mp4)`}
                                        inputName={sourceName}
                                        inputChangeHandler={handleChange}
                                        inputAdtype={CREATIVE_TYPE}
                                        isRequired={false}
                                        currentCustomer={currentCustomer}
                                        accept="video/mp4"
                                        defaultExtension="mp4"
                                    />
                                </TabPanel>
                                <TabPanel header="VAST tag">
                                    <InputTextSection
                                        label={`Third party VAST tag #${slot}`}
                                        name={sourceName}
                                        value={props[sourceName]}
                                        changeHandler={handleChange}
                                        adtype={CREATIVE_TYPE}
                                        required={false}
                                        uriEncodeValue={false}
                                    />
                                    <InputTextSection
                                        label="Approx. duration (seconds)"
                                        name={durationName}
                                        value={props[durationName]}
                                        changeHandler={handleChange}
                                        adtype={CREATIVE_TYPE}
                                        required={false}
                                    />
                                </TabPanel>
                            </TabView>
                            <InputTextSection
                                label={`Question #${slot}`}
                                name={STORY_UNIT_AD_FIELDS['question' + slot]}
                                value={props['question' + slot]}
                                changeHandler={handleChange}
                                adtype={CREATIVE_TYPE}
                                required={false}
                                uriEncodeValue={false}
                            />
                        </div>
                    )
                })}
                <InputTextSection
                    label="HTML container selector/wrapper (optional)"
                    name={STORY_UNIT_AD_FIELDS.container}
                    value={container}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    required={false}
                />
            </BaseCreativeControls>
        </>
    );
}
